import { styled } from "@mui/material/styles";

export const ProductInformationWrapper = styled("div")({
    gridArea: "content",
});
